import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { CButton, CCard, CCardBody, CCardHeader, CSpinner } from '@coreui/react';

import { apiClient } from 'services/Api';
import { jwtDecode } from 'jwt-decode';
import DataTableComponent from "components/DataTableComponent";
import RecordDetailOffcanvas from "components/RecordDetailOffcanvas";
import ToastNotification from 'components/globals/ToastNotification';

const CompetingCompanyList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [toast, setToast] = useState();

    const [companies, setCompanies] = useState([]);
    const [permissions, setPermissions] = useState({});
    const [isLoading, setIsLoading] = useState(true);  // Loading state
    const [hasPermission, setHasPermission] = useState(true);
    const [previewCompany, setPreviewCompany] = useState(null);

    const token = localStorage.getItem("access_token");
    const decodedToken = jwtDecode(token);
    const is_director = decodedToken.is_director;
    const user_id = decodedToken.user_id;

    useEffect(() => {
        const fetchCompanies = async () => {
            setIsLoading(true);  // Start loading
            try {
                const response = await apiClient.get(`/competing-companies/`);
                setCompanies(response.data.companies);
                setPermissions(response.data.permissions);
                setHasPermission(true);
            } catch (error) {
                if (error?.response?.status === 403) {
                    setHasPermission(false);
                } else {
                    setToast({ title: 'Empresas', message: 'Erro a carregar as empresas', type: 'error' });
                }
            } finally {
                setIsLoading(false);  // End loading
            }
        };

        fetchCompanies();
    }, [location.pathname]);

    const handleDelete = async (companyId) => {
        try {
            await apiClient.delete(`/competing-companies/${companyId}/`);
            setCompanies(companies.filter((company) => company.id !== companyId));
            setPreviewCompany((current) => (current && current.id === companyId ? null : current));
        } catch (error) {
            console.error('Error deleting company:', error);
        }
    };

    const columns = [
        { name: "NIF", selector: (row) => row.nif, sortable: true, className: 'text-center' },
        { name: "Nome", selector: (row) => row.name, sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <ToastNotification toast={toast} setToast={setToast} />

            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Empresas Concorrentes</h3>
                    {permissions.can_create && (
                        <Link to="/empresas-concorrentes/new">
                            <CButton color="info" className="text-white">Nova Empresa</CButton>
                        </Link>
                    )}
                </CCardHeader>
                <CCardBody>
                    {isLoading ? (
                        <div className="text-center">
                            <CSpinner color="primary" />
                        </div>
                    ) : hasPermission ? (
                        <DataTableComponent
                            columns={columns}
                            data={companies}
                            onRowClicked={setPreviewCompany}
                        />
                    ) : (
                        <p className="mb-0 text-danger">
                            Sem permissão para consultar as empresas concorrentes.
                        </p>
                    )}
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewCompany}
                onHide={() => setPreviewCompany(null)}
                title="Empresa Concorrente"
                subtitle={previewCompany?.name}
                fields={previewCompany ? [
                    { label: "NIF", value: previewCompany.nif },
                    { label: "Nome", value: previewCompany.name },
                ] : []}
                headerActions={previewCompany && <>
                    {permissions.can_update && (
                        <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/empresas-concorrentes/${previewCompany.id}`)}>
                            Editar
                        </CButton>
                    )}
                    {permissions.can_delete && (
                        <CButton color="danger" size="sm" className="text-white" onClick={() => {
                            if (window.confirm("Tem a certeza que quer eliminar este registo?")) handleDelete(previewCompany.id);
                        }}>
                            Eliminar
                        </CButton>
                    )}
                </>}
            />
        </>
    );


};

export default CompetingCompanyList;
